















import { PluginManager }               from "@/pluginManager/portalPlugin";
import externalComponent               from "@/utils/external-component";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name      : "PluginComponent",
  components: {}

})
export default class PluginComponent extends Vue {
  plugin: unknown = null;

  @Prop({
    required: true,
    type    : String
  })
  pluginUrl!: string;
  @Prop({
    default: () => ({}),
    type   : Object
  })
  pluginSettings: unknown;
  @Prop({
    required:true,
    default: () => ({}),
    type   : Object
  })
  pluginManager!: PluginManager;

  @Watch("pluginUrl", {immediate: true})
  loadPlugin(url: string, oldUrl: string): void {
    if (url === oldUrl) return;

    externalComponent(url).then(obj => {
      var ComponentClass = Vue.extend(obj);
      var instance       = new ComponentClass({propsData:{pluginSettings:this.pluginSettings, pluginManager:this.pluginManager}});
      console.log(instance)
      instance.$mount();
      (this.$refs.container as Element).appendChild(instance.$el);
    });
    this.plugin = () => Vue.extend();
  }
}
